/**
 *
 * @author Matthew Rawson @ 13/02/2018 17:17
 * @description
 * @notes
 */
import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import id from "@irati/utils/id"
import Button from "@irati/ui/src/Button"
import padding from "@irati/ui/src/global/padding"
import {greys} from "@irati/ui/src/global/colors"
import {minWidthMedia} from "@irati/ui/src/global/media"
import {injectIntl} from "@irati/utils/lang"

import {ProgressBar} from "./Progress"


const StyledFooterNav = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: ${greys.white};
  padding: ${padding.tiny};
`

const FooterNavContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 720px;
  margin-right: auto;
  margin-left: auto;
  transition: opacity 0.2s ease;

  ${(props) => (props.disabled ? "opacity: 0.3;" : "opacity: 1;")}

  ${minWidthMedia.desktop`
    max-width: 800px;
  `}
`


const FooterButton = styled(Button)`
  min-width: 95px;
  transition: none;

  ${(props) => (props.hide ? "visibility: hidden;" : "")}
`


class FooterNav extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    questionObj: PropTypes.object,
    onBack: PropTypes.func,
    onNext: PropTypes.func,
    formatMessage: PropTypes.func.isRequired,
    onSelectQuestionIndex: PropTypes.func
  };
  static defaultProps = {
    disabled: true,
    questionObj: {},
    onBack: () => (undefined),
    onNext: () => (undefined),
    onSelectQuestionIndex: () => (undefined)
  };


  constructor(props) {
    super(props)
    this.state = {}
  }


  render() {
    const idNamespace = id("footer-nav", this.props)
    const {questionObj, disabled, formatMessage} = this.props

    return (
      <StyledFooterNav id={idNamespace}>
        <FooterNavContent id={id("content", idNamespace)} disabled={disabled}>
          <FooterButton
            id={id("btn-back", idNamespace)}
            onClick={this.props.onBack}
            hide={questionObj.isFirst}
            disabled={disabled}>{formatMessage({id: "insights.userSurvey.footerNav.footerButton.previous"})}
          </FooterButton>

          <ProgressBar
            id={idNamespace}
            disabled={disabled}
            questionObj={questionObj}
            onClick={this.props.onSelectQuestionIndex} />

          <FooterButton
            id={id("btn-next", idNamespace)}
            primary={questionObj.isLast}
            disabled={disabled}
            onClick={this.props.onNext}>{questionObj.isLast
              ? formatMessage({id: "insights.userSurvey.footerNav.footerButton.submit"})
              : formatMessage({id: "insights.userSurvey.footerNav.footerButton.skip"})}
          </FooterButton>
        </FooterNavContent>
      </StyledFooterNav>
    )
  }
}

export default injectIntl(FooterNav)
